import React, { useEffect, useState } from 'react';
import './EducationalConsultancy.css';
import EmailApi from '../../components/common/index'; // Adjust path to match your project structure

function EducationalConsultancy() {
  const [formStatus, setFormStatus] = useState('');
  const [errors, setErrors] = useState({});

  const validateForm = (formData) => {
    const newErrors = {};

    const firstName = formData.get('firstName')?.trim();
    const email = formData.get('email')?.trim();
    const mobile = formData.get('mobile')?.trim();

    if (!firstName) {
      newErrors.firstName = 'First Name is required';
    }

    // Valid email format
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(email)) {
      newErrors.email = 'Please enter a valid email address (e.g., example@gmail.com)';
    }

    // Exactly 10 digits, starting with 6-9
    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobile) {
      newErrors.mobile = 'Mobile number is required';
    } else if (!mobileRegex.test(mobile)) {
      newErrors.mobile = 'Please enter a valid 10-digit Indian mobile number';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Prevent non-numeric input in mobile field
  const handleMobileKeyDown = (e) => {
    // Allow: backspace, delete, tab, escape, enter, arrows
    if ([8, 9, 27, 46, 13, 37, 38, 39, 40].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true)) {
      return;
    }
    // Block if not a number (0-9)
    if ((e.keyCode < 48 || e.keyCode > 57)) {
      e.preventDefault();
    }
  };

  // Prevent pasting non-numeric content
  const handleMobilePaste = (e) => {
    const pasted = (e.clipboardData || window.clipboardData).getData('text');
    if (!/^\d*$/.test(pasted)) {
      e.preventDefault();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('Sending...');
    setErrors({});

    const formData = new FormData(e.target);

    if (!validateForm(formData)) {
      setFormStatus('Please correct the errors above.');
      setTimeout(() => setFormStatus(''), 4000);
      return;
    }

    const firstName = formData.get('firstName');
    const lastName = formData.get('lastName');
    const email = formData.get('email');
    const mobile = formData.get('mobile');
    const message = formData.get('message');

    const params = new URLSearchParams();
    params.append('full_name', `${firstName} ${lastName || ''}`.trim());
    params.append('email', email);
    params.append('phone', mobile);
    params.append('subject', 'Educational Consultancy Inquiry');
    params.append('message', message || 'No additional message provided.');

    try {
      const { url, method } = EmailApi.SendMail;
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params,
      });

      if (response.ok) {
        setFormStatus('Thank you! We will get back to you soon 🚀');
        e.target.reset();
        setErrors({});
        setTimeout(() => {
          setFormStatus('');
          const popup = document.getElementById('educon-popupForm');
          if (popup) popup.classList.remove('active');
        }, 4000);
      } else {
        throw new Error(`Server responded with status: ${response.status}`);
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setFormStatus('Failed to send message. Please try again.');
      setTimeout(() => setFormStatus(''), 4000);
    }
  };

  useEffect(() => {
    // Popup toggle
    const contactBtn = document.getElementById("educon-contactBtn");
    const popupForm = document.getElementById("educon-popupForm");
    const closeBtn = document.getElementById("educon-closeBtn");

    if (contactBtn && popupForm && closeBtn) {
      contactBtn.addEventListener("click", () => {
        popupForm.classList.add("active");
      });
      closeBtn.addEventListener("click", () => {
        popupForm.classList.remove("active");
      });
      window.addEventListener("click", (e) => {
        if (e.target === popupForm) popupForm.classList.remove("active");
      });
    }

    // Animate cards on scroll
    const animatedEls = document.querySelectorAll(".educon-fade-up, .educon-zoom");
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    animatedEls.forEach(el => observer.observe(el));

    // Navbar scroll hide/show
    let lastScrollTop = 0;
    const header = document.querySelector('.educon-navbar');
    if (header) {
      window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll > lastScrollTop && currentScroll > 100) {
          header.style.top = "-100px"; // Hide
        } else {
          header.style.top = "0"; // Show
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      });
    }

    // Animate new service cards on scroll
    const serviceCards = document.querySelectorAll(".educon-service-card");
    serviceCards.forEach(card => observer.observe(card));

    // Mobile menu
    const hamburger = document.getElementById("educon-hamburger");
    const mobileMenu = document.getElementById("educon-mobileMenu");
    const mobileClose = document.getElementById("educon-mobileClose");
    const overlay = document.getElementById("educon-overlay");
    const toggles = document.querySelectorAll(".educon-mobile-toggle");

    if (hamburger && mobileMenu && overlay) {
      hamburger.addEventListener("click", () => {
        mobileMenu.classList.add("open");
        overlay.classList.add("open");
      });
    }

    if (mobileClose && mobileMenu && overlay) {
      mobileClose.addEventListener("click", () => {
        mobileMenu.classList.remove("open");
        overlay.classList.remove("open");
      });
    }

    if (overlay && mobileMenu) {
      overlay.addEventListener("click", () => {
        mobileMenu.classList.remove("open");
        overlay.classList.remove("open");
      });
    }

    toggles.forEach(toggle => {
      if (toggle) {
        toggle.addEventListener("click", () => {
          toggle.nextElementSibling.classList.toggle("open");
        });
      }
    });

    // Active links logic
    const navLinks = document.querySelectorAll(".educon-nav-links a");
    const mobileLinks = document.querySelectorAll(".educon-mobile-nav a");
    const dropdownButton = document.querySelector('.educon-dropbtn');
    const mobileToggle = document.querySelector('.educon-mobile-toggle');

    const currentPath = window.location.pathname.split('/').pop() || 'educationalconsultancy.html';

    function setActiveLink(link) {
      mobileLinks.forEach(l => l.classList.remove('active'));
      if (mobileToggle) mobileToggle.classList.remove('active');

      if (link) {
        link.classList.add('active');
        if (link.closest('.educon-dropdown-content') || link.closest('.educon-mobile-sub')) {
          if (dropdownButton) dropdownButton.classList.add('active');
          if (mobileToggle) mobileToggle.classList.add('active');
        }
      }
    }

    navLinks.forEach(link => {
      if (link.getAttribute('href') === currentPath) {
        setActiveLink(link);
      }
    });
    mobileLinks.forEach(link => {
      if (link.getAttribute('href') === currentPath) {
        setActiveLink(link);
      }
    });

    navLinks.forEach(link => {
      link.addEventListener("click", () => setActiveLink(link));
    });

    mobileLinks.forEach(link => {
      link.addEventListener("click", () => {
        setActiveLink(link);
        const mobileMenu = document.getElementById("educon-mobileMenu");
        const overlay = document.getElementById("educon-overlay");
        if (mobileMenu) mobileMenu.classList.remove("open");
        if (overlay) overlay.classList.remove("open");
      });
    });

    if (dropdownButton) {
      dropdownButton.addEventListener('click', () => {
        if (dropdownButton.classList.contains('active')) {
          dropdownButton.classList.remove('active');
        } else {
          setActiveLink(null);
          dropdownButton.classList.add('active');
        }
      });
    }

    if (mobileToggle) {
      mobileToggle.addEventListener('click', () => {
        if (mobileToggle.classList.contains('active')) {
          mobileToggle.classList.remove('active');
        } else {
          setActiveLink(null);
          mobileToggle.classList.add('active');
        }
      });
    }

  }, []); // Empty dependency array to run once on mount

  return (
    <>
      {/* Hero */}
      <section className="educon-hero">
        <h1>Educational Consultancy</h1>
      </section>

      {/* Education Consultancy Services */}
      <section className="educon-edu-services" id="edu-services">
        <h2>Education Consultancy Services</h2>
        <p className="educon-intro">
          At Oakya IT Services, we don’t just consult, we partner with you to transform challenges into opportunities. 
          Our consultancy process uncovers hidden gaps, crafts actionable strategies, and delivers results aligned with your long-term vision.
        </p>

        <div className="educon-service-container">
          <div className="educon-service-card educon-flip">
            <i className="fas fa-search"></i>
            <h3>Understanding Your Business</h3>
            <p>We dive deep into your model, market, and operations to uncover challenges and opportunities that matter.</p>
          </div>

          <div className="educon-service-card educon-bounce">
            <i className="fas fa-lightbulb"></i>
            <h3>Tailored Strategic Planning</h3>
            <p>Custom strategies built for your goals, customer needs, and industry trends—never one-size-fits-all.</p>
          </div>

          <div className="educon-service-card educon-fade-left">
            <i className="fas fa-cogs"></i>
            <h3>Technology & Process Optimization</h3>
            <p>We analyze your tools and workflows, recommending smarter, scalable solutions for agility and growth.</p>
          </div>

          <div className="educon-service-card educon-zoom-in">
            <i className="fas fa-hands-helping"></i>
            <h3>Implementation Support</h3>
            <p>We stay with you through execution—guiding adoption, process improvements, and delivering measurable outcomes.</p>
          </div>

          <div className="educon-service-card educon-fade-right">
            <i className="fas fa-chart-line"></i>
            <h3>Continuous Guidance & Growth</h3>
            <p>We provide ongoing consultancy, performance tracking, and adjustments to keep your business adaptive.</p>
          </div>
        </div>
      </section>

      {/* Gateway */}
      <section className="educon-gateway" id="gateway">
        <h2>Your Gateway to Premier Educational Institutions</h2>
        <p>
          At OAKYA IT SERVICES, we provide expert educational consultancy, partnering with top-tier universities to help you achieve your academic and career goals. 
          Our dedicated team ensures you receive tailored support throughout your educational journey.
        </p>

        <div className="educon-card-container">
          <div className="educon-card">
            <img src="images/sanjayguniversity.webp" alt="University 1" />
            <h3>Sanjay Ghodawat University</h3>     
            <p>A leader in research and innovation across various disciplines.</p>    
          </div>
          <div className="educon-card">
            <img src="images/joyuniversity.webp" alt="University 2" />
            <h3>JOY University</h3>
            <p>Offering a global education with a focus on real-world learning.</p>   
          </div>
          <div className="educon-card">
            <img src="images/sandipuniversity.webp" alt="University 3" />
            <h3>Sandip University</h3>
            <p>Known for its industry-oriented programs and excellent placements.</p>  
          </div>
          <div className="educon-card">
            <img src="images/orionuniversity.webp" alt="University 4" />
            <h3>Orion Technical College</h3>
            <p>Specializes in technical education with a hands-on approach.</p>    
          </div>
        </div>
      </section>

      {/* Why Choose */}
      <section className="educon-choose" id="choose">
        <h2>Why Choose OAKYA IT SERVICES?</h2>
        <div className="educon-card-container">
          <div className="educon-card educon-zoom"><img src="images/edupersonalguide.webp" alt="" /><h3>Personalized Guidance</h3><p>Tailored advice to align with your goals.</p></div>
          <div className="educon-card educon-zoom"><img src="images/eduapplicationasst.webp" alt="" /><h3>Application Assistance</h3><p>Support from start to finish in applications.</p></div>
          <div className="educon-card educon-zoom"><img src="images/educourseselection.webp" alt="" /><h3>Course Selection</h3><p>Expert help in choosing the right program.</p></div>
          <div className="educon-card educon-zoom"><img src="images/eduscholarship.webp" alt="" /><h3>Scholarship Guidance</h3><p>Find the best scholarships & financial aid.</p></div>
          <div className="educon-card educon-zoom"><img src="images/educareercounseling.webp" alt="" /><h3>Career Counseling</h3><p>Strategic advice for career-focused education.</p></div>
          <div className="educon-card educon-zoom"><img src="images/eduglobalnetwork.webp" alt="" /><h3>Global Network</h3><p>Access to international academic connections.</p></div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="educon-success" id="success">
        <h2>Success Stories</h2>
        <div className="educon-story-container">
          <div className="educon-story educon-fade-up">"OAKYA IT SERVICES expertise was crucial in my application process. Their support made my admission to SANJAY GHODAWAT University effortless." <br /><br />- Devi Mounica</div>
          <div className="educon-story educon-fade-up">"Thanks to OAKYA IT SERVICES, I received top-notch guidance throughout my application to GH RAISONI. The experience has been incredibly rewarding." <br /><br />- Leela Sagar</div>
        </div>
        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <button className="educon-get-btn" id="educon-contactBtn">Get in Touch with Us</button>
        </div>
      </section>

      {/* Popup Contact Form */}
      <div className="educon-popup" id="educon-popupForm">
        <div className="educon-popup-content">
          <h3>Contact Information</h3>
          <form onSubmit={handleSubmit} noValidate>
            <div className="educon-form-group">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                required
                className={errors.firstName ? 'error' : ''}
              />
              {errors.firstName && <span className="educon-error-text">{errors.firstName}</span>}
            </div>

            <input type="text" name="lastName" placeholder="Last Name" />

            <div className="educon-form-group">
              <input
                type="email"
                name="email"
                placeholder="Email (e.g., example@gmail.com)"
                required
                className={errors.email ? 'error' : ''}
              />
              {errors.email && <span className="educon-error-text">{errors.email}</span>}
            </div>

            <div className="educon-form-group">
              <input
                type="tel"
                name="mobile"
                placeholder="Mobile Number (10 digits)"
                required
                maxLength="10"
                className={errors.mobile ? 'error' : ''}
                onKeyDown={handleMobileKeyDown}
                onPaste={handleMobilePaste}
              />
              {errors.mobile && <span className="educon-error-text">{errors.mobile}</span>}
            </div>

            <textarea name="message" placeholder="Message (Optional)" rows="4"></textarea>

            <button type="submit" className="educon-btn">Submit</button>
            {formStatus && <p className="educon-form-status">{formStatus}</p>}
            <button type="button" className="educon-close-btn" id="educon-closeBtn">Close</button>
          </form>
        </div>
      </div>
    </>
  );
}

export default EducationalConsultancy;